import React, {
    useCallback,
    useEffect,
} from "react";

import {
    FiClock,
    FiRefreshCw,
} from "react-icons/fi";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import {
    fetchPurchaseAgeingReport,
    purchaseAgeingRecordsSelector,
    purchaseAgeingSummarySelector,
    purchaseReportLoadingSelector,
} from "../../../../../../../store/billing/purchaseReport/purchaseReportSlice";


const toNumber = (
    value
) =>
    Number.isFinite(
        Number(value)
    )
        ? Number(value)
        : 0;


const formatCurrency = (
    value
) =>
    new Intl.NumberFormat(
        "en-IN",
        {
            style: "currency",
            currency: "INR",
            minimumFractionDigits: 2,
        }
    ).format(
        toNumber(value)
    );


const AgeingReport = ({
    fromDate,
    toDate,
    financialYear,
}) => {
    const dispatch =
        useDispatch();

    const records =
        useSelector(
            purchaseAgeingRecordsSelector
        ) || [];

    const summary =
        useSelector(
            purchaseAgeingSummarySelector
        ) || {};

    const loading =
        useSelector(
            purchaseReportLoadingSelector
        ) || {};


    const loadData =
        useCallback(
            () => {
                dispatch(
                    fetchPurchaseAgeingReport({
                        asOfDate:
                            toDate,

                        financialYear,

                        page:
                            1,

                        limit:
                            200,
                    })
                );
            },
            [
                dispatch,
                fromDate,
                toDate,
                financialYear,
            ]
        );


    useEffect(
        () => {
            loadData();
        },
        [
            loadData,
        ]
    );


    return (
        <div>

            <section className="purchase-report-ageing-grid">

                <div>
                    <span>
                        Not Due
                    </span>

                    <strong>
                        {formatCurrency(
                            summary?.notDue
                        )}
                    </strong>
                </div>

                <div>
                    <span>
                        0 - 30 Days
                    </span>

                    <strong>
                        {formatCurrency(
                            summary?.days0To30
                        )}
                    </strong>
                </div>

                <div>
                    <span>
                        31 - 60 Days
                    </span>

                    <strong>
                        {formatCurrency(
                            summary?.days31To60
                        )}
                    </strong>
                </div>

                <div>
                    <span>
                        61 - 90 Days
                    </span>

                    <strong>
                        {formatCurrency(
                            summary?.days61To90
                        )}
                    </strong>
                </div>

                <div>
                    <span>
                        90+ Days
                    </span>

                    <strong>
                        {formatCurrency(
                            summary?.days90Plus
                        )}
                    </strong>
                </div>

            </section>


            <section className="purchase-report-table-card">

                {loading.ageing &&
                    records.length === 0 ? (
                    <div className="purchase-report-empty">
                        <FiRefreshCw className="purchase-report-spinner" />

                        <strong>
                            Loading ageing...
                        </strong>
                    </div>
                ) : records.length === 0 ? (
                    <div className="purchase-report-empty">
                        <FiClock />

                        <strong>
                            No ageing balance
                        </strong>
                    </div>
                ) : (
                    <div className="purchase-report-table-wrapper">

                        <table className="purchase-report-table">

                            <thead>
                                <tr>
                                    <th>
                                        Supplier
                                    </th>

                                    <th className="text-right">
                                        Not Due
                                    </th>

                                    <th className="text-right">
                                        0-30
                                    </th>

                                    <th className="text-right">
                                        31-60
                                    </th>

                                    <th className="text-right">
                                        61-90
                                    </th>

                                    <th className="text-right">
                                        90+
                                    </th>

                                    <th className="text-right">
                                        Total
                                    </th>
                                </tr>
                            </thead>


                            <tbody>
                                {records.map(
                                    (
                                        item,
                                        index
                                    ) => (
                                        <tr
                                            key={
                                                item?.supplierId ||
                                                index
                                            }
                                        >
                                            <td>
                                                <strong>
                                                    {item?.supplier?.supplierName || "-"}
                                                </strong>
                                            </td>

                                            <td className="text-right">
                                                {formatCurrency(
                                                    item?.notDue
                                                )}
                                            </td>

                                            <td className="text-right">
                                                {formatCurrency(
                                                    item?.days0To30
                                                )}
                                            </td>

                                            <td className="text-right">
                                                {formatCurrency(
                                                    item?.days31To60
                                                )}
                                            </td>

                                            <td className="text-right">
                                                {formatCurrency(
                                                    item?.days61To90
                                                )}
                                            </td>

                                            <td className="text-right">
                                                {formatCurrency(
                                                    item?.days90Plus
                                                )}
                                            </td>

                                            <td className="text-right">
                                                <strong className="purchase-report-outstanding">
                                                    {formatCurrency(
                                                        item?.totalOutstanding
                                                    )}
                                                </strong>
                                            </td>
                                        </tr>
                                    )
                                )}
                            </tbody>

                        </table>

                    </div>
                )}

            </section>
        </div>
    );
};


export default AgeingReport;